import client from "services/ngage/api-client";
import deserializeRole from "services/ngage/deserializers/role";
import {Role} from "types/Role";

/**
 * Get all roles
 */
const all = async () => {
    try{
        const data = (await client.get<Array<Role>>('/roles')).data || []
        return data.map(deserializeRole)
    } catch (error) {
        console.error("Unable to fetch roles", error)
        return []
    }
}

/**
 * Get a single role by ID
 *
 * @param {number} roleId
 */
const get = async (roleId: number) => {
    try{
        const data = (await client.get<Role|null>(`/roles/${roleId}`)) || null
        return data? deserializeRole(data) : null
    } catch (error) {
        console.error(`Unable to fetch role ${roleId}`, error)
        return null
    }
}

const roles = {
    all,
    get,
}

export default roles;